import React, { useState } from "react";
import AdBanner from "./AdBanner";

export const MODOS_JOGO = [
  {
    id: "perguntas",
    emoji: "❓",
    nome: "Modo Perguntas",
    tagline: "Todos recebem a mesma pergunta — responda de forma convincente!",
    cor: "#ff3e3e",
    corDim: "rgba(255,62,62,0.15)",
    disponivel: true,
    comoJogar: [
      "Todos os jogadores recebem a mesma pergunta.",
      "1 ou 2 jogadores serão impostores e recebem uma pergunta diferente.",
      "Cada jogador responde à sua pergunta em segredo.",
      "Os jogadores tentam descobrir o impostor analisando as respostas e fazendo perguntas durante o jogo.",
    ],
  },
  {
    id: "palavra-secreta",
    emoji: "🔐",
    nome: "Modo Palavra Secreta",
    tagline: "O modo clássico! Todos recebem a mesma palavra — exceto o impostor.",
    cor: "#9b6dff",
    corDim: "rgba(155,109,255,0.15)",
    disponivel: true,
    comoJogar: [
      "Todos os jogadores recebem a mesma palavra secreta (ex: 'Lasanha', 'Aeroporto', 'Hospital').",
      "1 ou 2 jogadores são impostores e recebem uma palavra diferente.",
      "Num tempo limite, os jogadores fazem perguntas uns aos outros (ex: 'O que você faria nesse lugar?', 'Quem você encontraria aí?').",
      "Os jogadores tentam descobrir o impostor pelas respostas e reações durante o jogo.",
    ],
  },
  {
    id: "duas-faccoes",
    emoji: "⚔️",
    nome: "Modo Duas Facções",
    tagline: "Jogadores divididos em times secretos — descubra quem está do seu lado!",
    cor: "#3effa3",
    corDim: "rgba(62,255,163,0.12)",
    disponivel: true,
    comoJogar: [
      "Metade dos jogadores recebe Palavra A (ex: 'Pizza') e a outra metade recebe Palavra B (ex: 'Hambúrguer').",
      "1 jogador é o impostor e recebe uma palavra diferente das duas.",
      "Os jogadores fazem perguntas e dão dicas tentando encontrar seu time — sem revelar sua palavra.",
      "O objetivo é descobrir o impostor E identificar quem está na sua facção antes dos adversários.",
    ],
  },
  {
    id: "descubra-nota",
    emoji: "🎯",
    nome: "Modo Descubra a Nota",
    tagline: "Teste a sintonia da dupla! Adivinhe a nota secreta do seu parceiro.",
    cor: "#f5c842",
    corDim: "rgba(245,200,66,0.15)",
    disponivel: true,
    comoJogar: [
      "Os jogadores são separados em duplas. Em cada dupla: um é o Dador de Dicas e o outro é o Adivinhador.",
      "O Dador de Dicas recebe uma nota secreta de 1 a 10 (ex: 'Nota 7').",
      "Num tempo limite, o Adivinhador faz perguntas de associação (ex: 'Um lugar com essa nota?', 'Uma comida com essa nota?', 'Uma celebridade?').",
      "Com base nas respostas e no conhecimento do parceiro, o Adivinhador deve acertar a nota exata antes do tempo acabar!",
    ],
  },
  {
    id: "adivinhe-musica",
    emoji: "🎵",
    nome: "Modo Adivinhe a Música",
    tagline: "O teste definitivo para ouvidos afiados! Descubra o hit pelo trecho.",
    cor: "#3eaaff",
    corDim: "rgba(62,170,255,0.12)",
    disponivel: true,
    comoJogar: [
      "A cada rodada, um jogador é o DJ (controla a música) e os outros são os Ouvintes.",
      "O DJ escolhe uma música em segredo e toca apenas os primeiros segundos da introdução ou um trecho curto.",
      "Os Ouvintes tentam descobrir o nome da música e/ou o artista o mais rápido possível.",
      "Se ninguém acertar, o DJ pode liberar mais alguns segundos — até alguém matar a charada!",
    ],
  },
  {
    id: "mega-senha",
    emoji: "🏆",
    nome: "Modo Mega Senha",
    tagline: "Versão super competitiva: todas as duplas disputam a mesma palavra em turnos!",
    cor: "#ff6b3e",
    corDim: "rgba(255,107,62,0.15)",
    disponivel: true,
    comoJogar: [
      "Separe os jogadores em duplas. Em cada uma: um é o Dador de Dicas e o outro é o Adivinhador.",
      "Uma palavra secreta é escolhida. Apenas os Dadores de Dica de todas as duplas veem a palavra.",
      "A primeira dupla tem sua vez: o Dador de Dicas diz apenas 1 palavra, e o parceiro tenta adivinhar a senha.",
      "Se errar, a vez passa à próxima dupla, que usa a nova dica + todas as anteriores. Quem acertar a palavra vence a rodada!",
    ],
  },
];

function ModeCard({ modo, onSelect, onHowToPlay }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      style={{
        background: "var(--bg-elevated)",
        border: `2px solid ${hovered && modo.disponivel ? modo.cor : "var(--border)"}`,
        borderRadius: 16,
        padding: "18px 20px",
        cursor: modo.disponivel ? "pointer" : "default",
        display: "flex",
        alignItems: "center",
        gap: 14,
        transition: "border-color 0.2s, box-shadow 0.2s",
        boxShadow: hovered && modo.disponivel ? `0 0 24px ${modo.cor}30` : "none",
        opacity: modo.disponivel ? 1 : 0.55,
        position: "relative",
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Ícone */}
      <div
        style={{
          fontSize: "2rem",
          background: modo.corDim,
          borderRadius: 12,
          width: 54,
          height: 54,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          border: `1px solid ${modo.cor}40`,
        }}
      >
        {modo.emoji}
      </div>

      {/* Info */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontFamily: "'Bebas Neue'",
            fontSize: "1.2rem",
            letterSpacing: "0.06em",
            color: "var(--text-primary)",
            display: "flex",
            alignItems: "center",
            gap: 8,
            flexWrap: "wrap",
          }}
        >
          {modo.nome}
          {!modo.disponivel && (
            <span
              style={{
                background: "rgba(155,109,255,0.15)",
                border: "1px solid #9b6dff",
                color: "#9b6dff",
                fontSize: "0.5rem",
                fontFamily: "'Space Mono'",
                padding: "2px 6px",
                borderRadius: 6,
                letterSpacing: "0.06em",
                verticalAlign: "middle",
              }}
            >
              EM BREVE
            </span>
          )}
        </div>
        <div
          style={{
            fontSize: "0.74rem",
            color: "var(--text-secondary)",
            marginTop: 2,
            lineHeight: 1.4,
          }}
        >
          {modo.tagline}
        </div>
      </div>

      {/* Botões */}
      <div style={{ display: "flex", flexDirection: "column", gap: 6, flexShrink: 0 }}>
        <button
          onClick={(e) => { e.stopPropagation(); onHowToPlay(modo); }}
          style={{
            background: "none",
            border: `1px solid var(--border)`,
            borderRadius: 8,
            color: "var(--text-secondary)",
            fontSize: "0.68rem",
            fontFamily: "'Space Mono'",
            padding: "4px 10px",
            cursor: "pointer",
            whiteSpace: "nowrap",
            transition: "border-color 0.2s, color 0.2s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = modo.cor;
            e.currentTarget.style.color = modo.cor;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = "var(--border)";
            e.currentTarget.style.color = "var(--text-secondary)";
          }}
        >
          Como jogar
        </button>

        {modo.disponivel && (
          <button
            onClick={(e) => { e.stopPropagation(); onSelect(modo.id); }}
            style={{
              background: modo.cor,
              border: "none",
              borderRadius: 8,
              color: "#fff",
              fontSize: "0.68rem",
              fontFamily: "'Bebas Neue'",
              letterSpacing: "0.08em",
              padding: "6px 12px",
              cursor: "pointer",
              whiteSpace: "nowrap",
              transition: "opacity 0.2s",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.opacity = "0.85"; }}
            onMouseLeave={(e) => { e.currentTarget.style.opacity = "1"; }}
          >
            Jogar →
          </button>
        )}
      </div>
    </div>
  );
}

function HowToPlayModal({ modo, onClose }) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1000,
        background: "rgba(0,0,0,0.8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px 16px calc(env(safe-area-inset-bottom, 0px) + 16px)",
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "var(--bg-card)",
          border: `1px solid ${modo.cor}40`,
          borderRadius: 20,
          width: "100%",
          maxWidth: 520,
          maxHeight: "85vh",
          overflowY: "auto",
          padding: "24px 20px",
          boxShadow: `0 0 40px ${modo.cor}25`,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <div
              style={{
                fontSize: "2.2rem",
                background: modo.corDim,
                borderRadius: 12,
                width: 56,
                height: 56,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: `1px solid ${modo.cor}50`,
                flexShrink: 0,
              }}
            >
              {modo.emoji}
            </div>
            <div>
              <div
                style={{
                  fontFamily: "'Bebas Neue'",
                  fontSize: "1.7rem",
                  letterSpacing: "0.06em",
                  color: modo.cor,
                  lineHeight: 1,
                }}
              >
                {modo.nome}
              </div>
              <div style={{ fontSize: "0.78rem", color: "var(--text-secondary)", marginTop: 4 }}>
                Como jogar
              </div>
            </div>
          </div>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              color: "var(--text-muted)",
              fontSize: "1.4rem",
              cursor: "pointer",
              lineHeight: 1,
              flexShrink: 0,
            }}
          >
            ✕
          </button>
        </div>

        {/* Descrição */}
        <div
          style={{
            background: modo.corDim,
            border: `1px solid ${modo.cor}30`,
            borderRadius: 12,
            padding: "12px 16px",
            fontSize: "0.82rem",
            color: "var(--text-secondary)",
            lineHeight: 1.6,
            marginBottom: 24,
          }}
        >
          {modo.tagline}
        </div>

        {/* Passos */}
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          {modo.comoJogar.map((passo, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: 14,
              }}
            >
              <div
                style={{
                  background: modo.corDim,
                  border: `2px solid ${modo.cor}`,
                  borderRadius: "50%",
                  width: 32,
                  height: 32,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontFamily: "'Bebas Neue'",
                  fontSize: "1rem",
                  color: modo.cor,
                  flexShrink: 0,
                }}
              >
                {i + 1}
              </div>
              <div
                style={{
                  fontSize: "0.85rem",
                  color: "var(--text-secondary)",
                  lineHeight: 1.6,
                  paddingTop: 5,
                }}
              >
                {passo}
              </div>
            </div>
          ))}
        </div>

        {/* Botões */}
        <div style={{ display: "flex", gap: 10, marginTop: 28 }}>
          <button
            className="btn btn-secondary"
            style={{ flex: 1 }}
            onClick={onClose}
          >
            Fechar
          </button>
          {modo.disponivel && (
            <button
              className="btn"
              style={{
                flex: 1,
                background: modo.cor,
                color: "#fff",
                border: "none",
              }}
              onClick={onClose}
            >
              Entendi, Jogar! →
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default function ModeSelectScreen({ onSelectMode, onBack }) {
  const [modalModo, setModalModo] = useState(null);

  return (
    <>
      {modalModo && (
        <HowToPlayModal
          modo={modalModo}
          onClose={() => setModalModo(null)}
        />
      )}

      <div className="app-wrapper" style={{ paddingTop: 88, paddingBottom: 32, justifyContent: "flex-start" }}>
        <AdBanner id="ad-mode-top" style={{ marginBottom: 20 }} />

        <div
          className="card"
          style={{ maxWidth: 520 }}
        >
          <div className="card-header">
            <button
              onClick={onBack}
              style={{
                background: "none",
                border: "none",
                color: "var(--text-muted)",
                fontSize: "0.8rem",
                fontFamily: "'Space Mono'",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 6,
                marginBottom: 12,
                padding: 0,
              }}
            >
              ← Voltar
            </button>
            <div className="title-eyebrow">🎮 Modo Local</div>
            <h1 className="title-main">
              Escolha o
              <br />
              <span style={{ color: "var(--accent)" }}>Modo de Jogo</span>
            </h1>
            <p className="title-sub">
              Selecione um dos modos abaixo para começar a partida.
            </p>
          </div>

          <div className="card-body" style={{ gap: 12, display: "flex", flexDirection: "column" }}>
            {MODOS_JOGO.map((modo) => (
              <ModeCard
                key={modo.id}
                modo={modo}
                onSelect={onSelectMode}
                onHowToPlay={setModalModo}
              />
            ))}
          </div>

          <div className="card-footer" style={{ flexDirection: "column" }}>
            <AdBanner id="ad-mode-bottom" />
          </div>
        </div>
      </div>
    </>
  );
}
